import MessageApi from '../../../../api/inbox/message';
import types from '../../../mutation-types';

export default {
  async translateMessage(
    { commit, rootGetters },
    { conversationId, messageId, targetLanguage }
  ) {
    const { data } = await MessageApi.translateMessage(
      conversationId,
      messageId,
      targetLanguage
    );

    const selectedChat = rootGetters.getSelectedChat;
    if (!selectedChat?.messages || !data?.content) return;

    const message = selectedChat.messages.find(
      storedMessage => storedMessage.id === messageId
    );
    if (!message) return;

    const translations = {
      ...(message.content_attributes?.translations || {}),
      [targetLanguage]: data.content,
    };

    commit(types.ADD_MESSAGE, {
      ...message,
      content_attributes: {
        ...message.content_attributes,
        translations,
      },
    });
  },
};
